import PropTypes from 'prop-types';
import React from 'react';

const NavigateLeft = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 21 56"
  >
    <path
      fill="currentColor"
      d="M19.594 17c0 0.25-0.125 0.531-0.312 0.719l-12.281 12.281 12.281 12.281c0.188 0.188 0.312 0.469 0.312 0.719s-0.125 0.531-0.312 0.719l-1.562 1.562c-0.188 0.188-0.469 0.312-0.719 0.312s-0.531-0.125-0.719-0.312l-14.563-14.563c-0.188-0.188-0.312-0.469-0.312-0.719s0.125-0.531 0.312-0.719l14.563-14.563c0.188-0.188 0.469-0.312 0.719-0.312s0.531 0.125 0.719 0.312l1.562 1.562c0.188 0.188 0.312 0.438 0.312 0.719z"
    />
  </svg>
);

NavigateLeft.defaultProps = {
  className: '',
};

NavigateLeft.propTypes = {
  className: PropTypes.string,
};

export default NavigateLeft;
